export const PRIZE_WALL_CAMPAIGN_BANNER_CONTAINER_STYLES = {};
